export default __webpack_public_path__ + "static/media/Desktop.4b3d14db.jpg";